"use strict";

$(function () {
    if ($(".page--where2buy").length != 0) {
        var getData = function getData(url) {
            $.ajax({
                url: url,
                dataType: 'json'
            }).done(function (data) {
                removeMarkers();
                $('.dealer-wrapper').html('');
                $('.mobile-dealer-wrapper').html('');

                if(data){
                    if (data.length == 0) {
                        $('.no-service-message').show();
                    } else {
                        $('.no-service-message').hide();
                        for (var i = 0; i < data.length; i++) {
                            var dealer = data[i];
                            var address = dealer.address;

                            if (dealer.suburb) {
                                address = address + ", " + dealer.suburb;
                            }

                            var html = `
                                <div class="row dealer-container">
                                    <div class="column col-md-12 col-12">
                                        <h3>${dealer.name}</h3>
                                        <div class="">
                                            <img src="resources/themes/silverstripe-bootstarter/dist/img/marker-icon.svg">${address}
                                        </div>
                                        <div class=" ">
                                            <img src="resources/themes/silverstripe-bootstarter/dist/img/phone-icon.svg"> <a class="link" href="tel:${dealer.phone}">${dealer.phone}</a>
                                        </div>
                                        `;
                            if(dealer.email){
                                html += `<div class=" ">
                                            <img src="resources/themes/silverstripe-bootstarter/dist/img/email-icon.svg"> <a class="link" href="mailto:${dealer.email}">${dealer.email}</a>
                                        </div>`;
                            }
                            html += '</div></div>';

                            data[i].lat = parseFloat(dealer.lat);
                            data[i].lng = parseFloat(dealer.lng);

                            if (screen.width < 1350) {
                                $('.mobile-dealer-wrapper').append(html);
                                $(".dealer-container .view-map-btn").eq(0).focus();
                            } else {
                                $('.dealer-wrapper').append(html);
                                $(".dealer-container .view-map-btn").eq(0).focus();
                            }
                        }
                        addMarker(data);
                    }
                }
            }).fail(function (err) {
                console.log(err);
            });
        };

        var submitForm = function submitForm() {
            var formData = $("#dataForm").serialize();
            var url = $("#dataForm").attr('action') + "?" + formData;
            getData(url);
        };

        var buildMap = function buildMap(locationLat, locationLng) {
            map = new google.maps.Map(document.getElementById('map'), {
                center: {
                    lat: locationLat,
                    lng: locationLng
                },
                zoom: 9
            });
        };

        var removeMarkers = function removeMarkers() {
            for (var i = 0; i < markers.length; i++) {
                markers[i].setMap(null);
            }

            markers = [];
        };

        var addMarker = function addMarker(locations) {
            for (var i = 0; i < locations.length; i++) {
                var location = locations[i];
                var marker = new google.maps.Marker({
                    position: location,
                    map: map,
                    tooltip: '<p><strong>' + location.name + '</strong></p> <p>Address: ' + location.address + '</p> <p>Phone: <a href="tel:' + location.phone + '">' + location.phone + '</a></p>'
                });
                markers.push(marker);
                marker.addListener('click', function () {
                    infowindow.setContent(this.tooltip);
                    infowindow.open(map, this);
                });
            }
        };

        var lat = -36.8492847;
        var lng = 174.7583554;
        var markers = [];
        var map;
        var input = document.getElementById('location-input');
        var options = {
            componentRestrictions: {
                country: "nz"
            }
        };
        var autocomplete = new google.maps.places.Autocomplete(input, options);
        buildMap(lat, lng);

        $("#dataForm").submit(function (e) {
            e.preventDefault();
            submitForm();
        });
        $(".submit-btn").click(function (e) {
            e.preventDefault();
            submitForm();
        });
        $(".find-nearby-btn").click(function () {
            var userLat, userLng;

            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(function (position) {
                    userLat = position.coords.latitude;
                    userLng = position.coords.longitude;

                    $("#latInput").val(userLat);
                    $("#lngInput").val(userLng);
                    submitForm();

                    map.setCenter({
                        lat: userLat,
                        lng: userLng
                    });
                    map.setZoom(9);
                });
            }
        });
        autocomplete.setFields(['address_components', 'geometry', 'icon', 'name']);
        autocomplete.addListener('place_changed', function () {
            var place = autocomplete.getPlace();
            if(place){
                var lat = place.geometry.location.lat();
                var lng = place.geometry.location.lng();
                map.setCenter({
                    lat: lat,
                    lng: lng
                });
                map.setZoom(9);
                $("#latInput").val(lat);
                $("#lngInput").val(lng);
            }
        });
        var infowindow = new google.maps.InfoWindow({
            content: ''
        });
        $(".business-type-select").change(function () {
            if ($(".business-type-select:checked").length == $(".business-type-select").length) {
                $(".business-type-all").prop('checked', true);
            } else {
                $(".business-type-all").prop('checked', false);
            }
        });
        $(".business-type-all").change(function () {
            if ($(this).is(":checked")) {
                $(".business-type-select").prop('checked', true);
            } else {
                $(".business-type-select").prop('checked', false);
            }
        });
        /*  $(document).on('click', '.view-map-btn', function (e) {
              e.preventDefault();
              var location = $(this).data('location');
              $(".view-map-btn").removeClass('active');
              $(this).addClass('active');
              location.lat = parseFloat(location.lat);
              location.lng = parseFloat(location.lng);
              addMarker(location);
              console.log(location);
              if(screen.width < 992){
                  $(this).closest('.button-column').next().after($('#map'));
              }
          });*/
    }
});
